import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { icons } from '../../../assets';
// eslint-disable-next-line
export const UserPerfilCemex = ({ grupo, nameUser, matricula, Fecha_y_hora }) => {
    const { arrayData } = useSelector((state) => state.table);
    const { typeAdmin } = useSelector((state) => state.auth)
    const [pointsUpper, setpointsUpper] = useState(0)
    const [timeTotalUser, setTimeTotalUser] = useState(0)
    const { proyectSelected } = useSelector((state) => state.vrtSlice);
    const { proyects } = useSelector((state) => state.vrlSlice);
    const [pageSelected, setpageSelected] = useState(0)

    const { responses } = useSelector((state) => {
        if (typeAdmin === "VRT") {
            return state.vrtSlice
        }
        else {
            return state.vrlSlice
        }
    });
    // eslint-disable-next-line
    const [dataFilterPerUser, setFileterData] = useState([])

    const formatedDate = (date) => {
        const fecha = new Date(date);
        return fecha.toLocaleString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
        });
    }


    const userHighPoints = (dataFilterPerUser) => {
        const element = dataFilterPerUser.reduce((max, elemento) =>
            parseInt(elemento.puntaje) > parseInt(max.puntaje) ? elemento : max, { puntaje: '0/100' }
        );
        setpointsUpper(dataFilterPerUser.length ? element.puntaje : 0);
    }

    const userTimeTotal = (dataFilterPerUser) => {
        const sumaTiempoTotal = dataFilterPerUser.reduce((total, elemento) => {
            const minutos = parseInt(elemento.tiempo_total.split(' ')[0], 10);
            return total + minutos;
        }, 0);
        const horas = Math.floor(sumaTiempoTotal / 60);
        const minutosRestantes = sumaTiempoTotal % 60;

        setTimeTotalUser(horas + ":" + minutosRestantes)
    }


    const onchangePage = (next) => {
        setpageSelected(actual => {
            const suma = actual + next
            if (suma >= dataFilterPerUser.length) {
                return 0
            }
            if (suma <= -1) {
                return dataFilterPerUser.length - 1
            }
            else {
                return suma
            }

        })
    }

    useEffect(() => {

        // if (typeAdmin === "VRT" && proyectSelected === "66fafd1d92bbc20883798c43") {
        // console.log(arrayData)
        const conjunts = arrayData.reduce((acc, curr) => {

            // Verificar si la matrícula es igual a la que estamos evaluando
            if (curr.matricula === matricula) {
                const fecha = curr.Fecha_y_hora.split("T")[0];
                const key = `${curr.matricula}-${fecha}`;
                if (!acc[key]) {
                    acc[key] = {
                        Nombre: curr.Nombre,
                        Fecha_y_hora: curr.Fecha_y_hora,
                        tiempo_total: curr.tiempo_total,
                        Porcentaje_total: curr.Porcentaje_total,
                        matricula: curr.matricula,
                        puntaje: curr.puntaje,
                        initialDate: formatedDate(curr.Fecha_y_hora),
                        endDate: formatedDate(curr.Fecha_y_hora),
                        M1: 0,
                        M2: 0,
                        M3: 0,
                        M4: 0,
                        M1_L1: { correct: 0, incorrect: 0 },
                        M1_L2: { correct: 0, incorrect: 0 },
                        M1_L3: { correct: 0, incorrect: 0 },
                        M1_L4: { correct: 0, incorrect: 0 },
                        M1_L5: { correct: 0, incorrect: 0 },
                        M1_L6: { correct: 0, incorrect: 0 },
                        M2_L1: { correct: 0, incorrect: 0 },
                        M2_L2: { correct: 0, incorrect: 0 },
                        M2_L3: { correct: 0, incorrect: 0 },
                        M2_L4: { correct: 0, incorrect: 0 },
                        M2_L5: { correct: 0, incorrect: 0 },
                        M3_L1: { correct: 0, incorrect: 0 },
                        M3_L2: { correct: 0, incorrect: 0 },
                        M3_L3: { correct: 0, incorrect: 0 },
                        M3_L4: { correct: 0, incorrect: 0 },
                        M4_L1: { correct: 0, incorrect: 0 },
                        M4_L2: { correct: 0, incorrect: 0 },
                        M4_L3: { correct: 0, incorrect: 0 },
                        M4_L4: { correct: 0, incorrect: 0 },
                        M4_L5: { correct: 0, incorrect: 0 },
                    };
                }
                for (let keyLocal of ["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6", "M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5", "M3_L1", "M3_L2", "M3_L3", "M3_L4", "M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"]) {
                    if (curr[keyLocal] === "True") {
                        acc[key][keyLocal].correct += 1;

                    } else {
                        if (curr[keyLocal] !== "*" && curr[keyLocal])
                            acc[key][keyLocal].incorrect += 1;
                    }
                }

                // Comparar y guardar el puntaje más alto
                const currPuntaje = parseInt(curr.puntaje.split("/")[0], 10);
                const accPuntaje = parseInt(acc[key].puntaje.split("/")[0], 10);
                if (currPuntaje > accPuntaje) {
                    acc[key].puntaje = curr.puntaje;
                }
                if (new Date(curr.Fecha_y_hora) > new Date(acc[key].initialDate)) {

                    acc[key].initialDate = formatedDate(curr.Fecha_y_hora);
                }
                if (new Date(curr.Fecha_y_hora) < new Date(acc[key].endDate)) {

                    acc[key].endDate = formatedDate(curr.Fecha_y_hora);
                }
            }

            return acc;
        }, {});
        const arrayConjunt = Object.values(conjunts);
        arrayConjunt.forEach(element => {
            for (let keyLocal of ["M1_L1", "M1_L2", "M1_L3", "M1_L4", "M1_L5", "M1_L6", "M2_L1", "M2_L2", "M2_L3", "M2_L4", "M2_L5", "M3_L1", "M3_L2", "M3_L3", "M3_L4", "M4_L1", "M4_L2", "M4_L3", "M4_L4", "M4_L5"]) {
                // console.log("------")
                if ((element[keyLocal].correct + element[keyLocal].incorrect) > element[keyLocal.substring(0, 2)]) {
                    element[keyLocal.substring(0, 2)] = element[keyLocal].correct + element[keyLocal].incorrect
                }
                // console.log(element)
            }
        })
        // console.log("*******")
        // console.log(arrayConjunt)
        setFileterData(arrayConjunt);
        userHighPoints(arrayConjunt);
        userTimeTotal(arrayConjunt)
    }, [responses, proyectSelected, arrayData, Fecha_y_hora, matricula, typeAdmin, nameUser])


    return (
        <div className='w-full h-full flex flex-col py-6 px-10'>
            <div className='pl-4 w-full h-5/12 flex'>
                <div className='w-10 h-10 rounded-full flex justify-center items-center bg-blue-600 mr-4'>
                    <p className='text-white font-semibold text-xs'> {nameUser.split(" ")[0].substring(0, 2).toUpperCase()}</p>
                </div>
                <InfoUser title={"Nombre"} text={nameUser} />
                <InfoUser title={"Matrícula"} text={matricula} />
                {proyectSelected === "66fafd1d92bbc20883798c43" && <InfoUser title={"Fecha"} text={new Date(Fecha_y_hora).toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })} />}
            </div>
            <div className="pl-16 pt-6">
                <p className='text-black text-2xl font-semibold leading-5'>Curso: {proyects.find(proyect => proyect._id === proyectSelected).name}</p>
            </div>
            <div className='w-full  flex h-12 justify-center gap-x-8 py-3'>
                <div className='flex w-[210px]'>
                    <img src={icons.watch} className='h-6 w-6' alt="icon time total" />
                    <div className='pl-2'>
                        <p className='text-xs text-[#686868] leading-5'>Tiempo total invertido</p>
                        <p className='text-xl font-medium text-[#282828] leading-5'>{timeTotalUser} hrs.</p>
                    </div>
                </div>
                <div className='flex w-[210px]'>
                    <img src={icons.shield} className='h-6 w-6' alt="icon time total" />
                    <div className='pl-2'>
                        <p className='text-xs text-[#686868] leading-5'>Puntaje más alto</p>
                        <p className='text-xl font-medium text-[#282828] leading-5'>{pointsUpper}</p>
                    </div>
                </div>
            </div>
            <div className="w-full flex justify-center items-center pt-4">
                {
                    dataFilterPerUser.length >= 2 &&
                <div
                            onClick={() => { onchangePage(-1) }}
                            className='h-full flex justify-center items-center mr-4 cursor-pointer'>
                    <div className='w-10 h-10 rounded-lg shadowBtnNext flex justify-center items-center'>
                        <img src={icons.mayorqueicon} className='h-6 transform rotate-180' alt="" />
                    </div>
                </div>
                }
                {/*  */}
                <div className='w-[744px] h-[356px] rounded-3xl shadow-3xl py-8 px-4'>
                    <div className='flex w-full gap-4 pb-4'>
                        {/* <div className='flex gap-2'>
                            <img src={icons.initialDate} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868]'>Fecha inicial</p>
                                <p>{dataFilterPerUser[pageSelected]?.initialDate || 'Sin fecha'}</p>
                            </div>
                        </div> */}
                        <InfoIntent icon={icons.initialDate} title={'Fecha inicial'} data={dataFilterPerUser[pageSelected]?.initialDate || 'Sin fecha'}></InfoIntent>
                        <InfoIntent icon={icons.endDate} title={'Fecha final'} data={dataFilterPerUser[pageSelected]?.initialDate || 'Sin fecha'}></InfoIntent>
                        <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Estatus</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: dataFilterPerUser[pageSelected]?.Porcentaje_total || '0%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected]?.Porcentaje_total.split('%')[0] < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='flex gap-2'>
                            <img src={icons.progress} className="w-6 h-6" alt="icono de fecha" />
                            <div>
                                <p className='text-[#686868] text-xs font-medium '>Puntaje</p>
                                <div className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>
                                    <p className='w-[112px] text-center leading-5 py-1'>{dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}</p>
                                    <div className='w-full h-1 bg-[#d9d9d9] rounded'>
                                        <div
                                            style={{ width: dataFilterPerUser[pageSelected]?.puntaje.split('/')[0] + '%' || '0%' }}
                                            className={`h-full ${dataFilterPerUser[pageSelected]?.puntaje.split('/')[0] < 100 ? 'bg-[#F2B840]' : 'bg-[#89EB7E]'} `}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <InfoIntent icon={icons.progress} title={'Progreso'} data={dataFilterPerUser[pageSelected]?.Porcentaje_total || 'Sin progreso'}></InfoIntent> */}
                        {/* <InfoIntent icon={icons.pointsSheld} title={'Puntaje'} data={dataFilterPerUser[pageSelected]?.puntaje || 'Sin puntaje'}></InfoIntent> */}
                    </div>
                    <div className='w-full h-10 bg-3366FF rounded flex'>
                        <div className='w-4/12 flex justify-start items-center px-2'>
                            <p className='text-white font-bold text-xs'>Módulos</p>
                        </div>
                        <div className='w-4/12 flex justify-start items-center'>
                            <p className='text-white font-bold text-xs'>Pasos (# repetición por paso)</p>
                        </div>
                        <div className='w-3/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            <p className='text-white font-bold text-xs'>Repeticiones</p>
                        </div>
                        <div className='w-2/12 flex justify-center items-center'>
                            <p className='text-white font-bold text-xs'>Gemas</p>
                        </div>
                    </div>
                    {/* epp */}
                    <div className='w-full flex py-2'>
                        <div className='w-4/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>EPP</p>
                        </div>
                        <div className='w-4/12'>
                            <div className='flex flex-wrap gap-2 w-[160px]'>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L1'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L2'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L3'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L4'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L5'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M1_L6'}></CubeSteap>
                                <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                                <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                                <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                                <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>

                        </div>
                        </div>
                        <div className='w-3/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>{dataFilterPerUser[pageSelected]?.M1}</div>
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {dataFilterPerUser[pageSelected]?.M1_L1.incorrect >= 1 ? "2/3" : '3/3'}
                        </div>
                    </div>
                    {/* previo a utilizar  */}
                    <div className='w-full flex py-2'>
                        <div className='w-4/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Previo a utilizar canalones</p>
                        </div>
                        <div className='w-4/12 flex flex-wrap gap-2'>
                            {/* <div className={`w-8 h-8 rounded-lg flex justify-center items-center text-white font-semibold ${dataFilterPerUser[pageSelected]?.M2_L1.incorrect >= 1 ? "bg-[#DF3C3C]" : "bg-[#89EB7E]"}`}>
                                {dataFilterPerUser[pageSelected] ? dataFilterPerUser[pageSelected].M2_L1.correct + dataFilterPerUser[pageSelected].M2_L1.incorrect : 'X'}
                            </div> */}
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M2_L1'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M2_L2'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M2_L3'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M2_L4'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M2_L5'}></CubeSteap>

                        </div>
                        <div className='w-3/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>{dataFilterPerUser[pageSelected]?.M2}</div>
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {dataFilterPerUser[pageSelected]?.M2_L1.incorrect >= 1 ? "2/3" : '3/3'}
                        </div>
                    </div>
                    {/* despliegue */}
                    <div className='w-full flex py-2'>
                        <div className='w-4/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Despliegue inicial</p>
                        </div>
                        <div className='w-4/12 flex flex-wrap gap-2'>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M3_L1'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M3_L2'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M3_L3'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M3_L4'}></CubeSteap>
                            <div className='w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold bg-black opacity-5'></div>
                        </div>
                        <div className='w-3/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>{dataFilterPerUser[pageSelected]?.M3}</div>
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {dataFilterPerUser[pageSelected]?.M3_L1.incorrect >= 1 ? "2/3" : '3/3'}
                        </div>
                    </div>
                    {/*  */}
                    <div className='w-full flex py-2'>
                        <div className='w-4/12 flex justify-start items-center px-2'>
                            <p className='text-xs font-medium text-[#686868]'>Plegar al final de la descarga</p>
                        </div>
                        <div className='w-4/12 flex flex-wrap gap-2'>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M4_L1'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M4_L2'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M4_L3'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M4_L4'}></CubeSteap>
                            <CubeSteap dataFilterPerUser={dataFilterPerUser} pageSelected={pageSelected} steap={'M4_L5'}></CubeSteap>
                        </div>
                        <div className='w-3/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>{dataFilterPerUser[pageSelected]?.M4}</div>
                        <div className='w-2/12 flex justify-center items-center text-[#9A9A9A] text-xs font-medium'>
                            {dataFilterPerUser[pageSelected]?.M4_L1.incorrect >= 1 ? "2/3" : '3/3'}
                        </div>
                    </div>

                </div>
                {/*  */}
                {
                    dataFilterPerUser.length >= 2 &&
                <div
                            onClick={() => { onchangePage(1) }}
                            className='h-full flex justify-center items-center pl-4 cursor-pointer'>
                    <div className='w-10 h-10 rounded-lg shadowBtnNext flex justify-center items-center'>
                        <img src={icons.mayorqueicon} className='h-6 ' alt="" />
                    </div>
                </div>
                }
            </div>
            <div className='w-full flex justify-center gap-x-2 pt-4'>
                {dataFilterPerUser.length >= 2 && <PageViewer pageSelected={pageSelected} dataFilterPerUser={dataFilterPerUser.length}></PageViewer>}

            </div>
        </div>
    )
}


const PageViewer = ({ pageSelected, dataFilterPerUser }) => {
    const rows = []
    for (let index = 0; index < dataFilterPerUser; index++) {
        rows.push(
            <div key={index} className={`w-2 h-2 
                ${pageSelected === index ? "bg-[#14A6E0] bg-opacity-100" : "bg-black bg-opacity-40"}
                 rounded-full`}></div>
        )
    }
    return rows
}

const InfoUser = ({ title, text }) => {
    return (
        <div className='w-2/6 h-full'>
            <p className='text-[#686868]  text-xs font-medium leading-5'>{title}</p>
            <p className='text-[#454545] text-xs font-normal pt-1 leading-5'>{text}</p>
        </div>
    )
}

const CubeSteap = ({ dataFilterPerUser, pageSelected, steap }) => {
    return (
        <div className={`w-6 h-6 rounded-[4px] flex justify-center items-center text-xs text-white font-semibold 
        ${dataFilterPerUser[pageSelected]?.[steap].incorrect >= 1 ? "bg-[#DF3C3C]" :
            (dataFilterPerUser[pageSelected]?.[steap].correct + dataFilterPerUser[pageSelected]?.[steap].incorrect) === 0 ? "bg-[#00000020]" :
                    "bg-[#89EB7E]"}`}>
            {dataFilterPerUser[pageSelected] ? dataFilterPerUser[pageSelected][steap].correct + dataFilterPerUser[pageSelected][steap].incorrect : 'X'}
        </div>
    )
}

const InfoIntent = ({ icon, title, data }) => {
    return (
        <div className='flex gap-2'>
            <img src={icon} className="w-6 h-6" alt="icono de fecha" />
            <div>
                <p className='text-[#686868] text-xs font-medium leading-5'>{title}</p>
                <p className='w-[112px] text-[#9A9A9A] text-xs font-normal leading-5'>{data}</p>
            </div>
        </div>
    )
}


export default UserPerfilCemex
